export const isValidEmail = (email: string) => {
  const emailRegex = /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return emailRegex.test(email);
};
export const isValidPhoneNumber = (phone: string): boolean => {
  const trimmedPhone = phone.trim();
  const patternWithPlus44 = /^(\+?44)\s?\d{3,5}\s?\d{5,6}$/;
  const patternWithoutPlus44 = /^0?\d{3,5}\s?\d{5,6}$/;
  return patternWithPlus44.test(trimmedPhone) || patternWithoutPlus44.test(trimmedPhone);
};
